import React from 'react';
import Form from '../../../components/common/Form';

class NotificationStatistics extends Form {
    constructor(props) {
        super(props);
        this.state = {
            sent_posts_total: this.props.sent_posts_total,
            opened_posts_total: this.props.opened_posts_total,
            percent_posts_total: this.props.percent_posts_total,
            sent_posts_fb_total: this.props.sent_posts_fb_total,
            opened_posts_fb_total: this.props.opened_posts_fb_total,
            percent_posts_fb_total: this.props.percent_posts_fb_total,
            facebook_pages_total: this.props.facebook_pages_total,
            sent_posts_wp_total: this.props.sent_posts_wp_total,
            opened_posts_wp_total: this.props.opened_posts_wp_total,
            percent_posts_wp_total: this.props.percent_posts_wp_total,
            sent_posts_slack_total: this.props.sent_posts_slack_total,
            opened_posts_slack_total: this.props.opened_posts_slack_total,
            percent_posts_slack_total: this.props.percent_posts_slack_total,
            slack_channels: this.props.slack_channels,
            errors: {}
        };
    }

    componentDidUpdate = () => {
        if (this.state.sent_posts_total !== this.props.sent_posts_total) {
            this.setState({sent_posts_total: this.props.sent_posts_total});
        }
        if (this.state.opened_posts_total !== this.props.opened_posts_total) {
            this.setState({opened_posts_total: this.props.opened_posts_total});
        }
        if (this.state.percent_posts_total !== this.props.percent_posts_total) {
            this.setState({percent_posts_total: this.props.percent_posts_total});
        }

        if (this.state.facebook_pages_total !== this.props.facebook_pages_total) {
            this.setState({facebook_pages_total: this.props.facebook_pages_total});
        }

        if (this.state.sent_posts_fb_total !== this.props.sent_posts_fb_total) {
            this.setState({sent_posts_fb_total: this.props.sent_posts_fb_total});
        }
        if (this.state.opened_posts_fb_total !== this.props.opened_posts_fb_total) {
            this.setState({opened_posts_fb_total: this.props.opened_posts_fb_total});
        }
        if (this.state.percent_posts_fb_total !== this.props.percent_posts_fb_total) {
            this.setState({percent_posts_fb_total: this.props.percent_posts_fb_total});
        }

        if (this.state.sent_posts_wp_total !== this.props.sent_posts_wp_total) {
            this.setState({sent_posts_wp_total: this.props.sent_posts_wp_total});
        }
        if (this.state.opened_posts_wp_total !== this.props.opened_posts_wp_total) {
            this.setState({opened_posts_wp_total: this.props.opened_posts_wp_total});
        }
        if (this.state.percent_posts_wp_total !== this.props.percent_posts_wp_total) {
            this.setState({percent_posts_wp_total: this.props.percent_posts_wp_total});
        }
    }

    render() {
        const {
            sent_posts_fb_total, opened_posts_fb_total, percent_posts_fb_total, facebook_pages_total,
            sent_posts_total, opened_posts_total, percent_posts_total,
            sent_posts_wp_total, opened_posts_wp_total, percent_posts_wp_total,
            sent_posts_slack_total, opened_posts_slack_total, percent_posts_slack_total, slack_channels
        } = this.state;

        return (
            <div className="col-xl-3">
                <p>Notification Statistics</p>
                <label className="grey-text">Displayed for selected period</label>
                <div className="row">
                    <div className="col-xs-7">
                        <span className="subs text-bold m-k-b">{percent_posts_total}</span>
                    </div>
                    <div className="col-xs-5 text-right">
                        <div className="open-info m-k-b">
                            <label className="text-right">Sent <span className="far fa-envelope"></span></label>
                            <span className="text-bold">{sent_posts_total}</span>
                        </div>
                        <div className="open-info">
                            <label className="text-right">Opened <span className="far fa-envelope-open"></span></label>
                            <span className="text-bold">{opened_posts_total}</span>
                        </div>
                    </div>
                </div>
                <div className="row subs-per-channel m-m-t">
                    <div className="col-xs-12">
                        <p className="text-bold m-xs-b"><span className="fab fa-facebook-messenger"></span> FB messenger
                            <span className="right">{sent_posts_fb_total}/{opened_posts_fb_total}<span
                                className="percent">{percent_posts_fb_total}</span></span>
                        </p>
                        <div className="separator m-k-b"></div>
                        {facebook_pages_total && facebook_pages_total.map((page, index) =>
                            <label key={index}>{page.fb_page}
                                <span className="right">{page.sent_posts}/{page.opened_posts}
                                    <span className="percent">{page.percent_posts}</span>
                                </span>
                            </label>
                        )}
                    </div>
                </div>
                {sent_posts_wp_total ? <div className="row subs-per-channel m-m-t">
                        <div className="col-xs-12">
                            <p className="text-bold m-xs-b"><span className="fab fas fa-globe"></span> Web Push
                                <span className="right">{sent_posts_wp_total}/{opened_posts_wp_total}<span
                                    className="percent">{percent_posts_wp_total}</span></span>
                            </p>
                            <div className="separator"></div>
                        </div>
                    </div>
                    :
                    ""
                }
                {opened_posts_slack_total ? <div className="row subs-per-channel m-m-t">
                        <div className="col-xs-12">
                            <p className="text-bold m-xs-b"><span className="fab fa-slack"></span> Slack
                                <span className="right">{sent_posts_slack_total}/{opened_posts_slack_total} <span
                                    className="percent">{percent_posts_slack_total}</span></span>
                            </p>
                            <div className="separator m-k-b"></div>
                            {slack_channels && slack_channels.map((channel, index) =>
                                <label key={index}>{channel.channel}
                                    <span className="right">{channel.opened_posts}/{channel.sent_posts}
                                        <span className="percent">{channel.percent_posts}</span>
                                    </span>
                                </label>
                            )}
                        </div>
                    </div>
                    :
                    ""
                }
            </div>
        )
    }
}

export default NotificationStatistics